import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Analytics from '../utils/analytics';

const GoogleAnalytics = ({ location: { pathname } }) => {
  useEffect(() => {
    Analytics.page();
  }, [pathname]);

  return null;
};

GoogleAnalytics.propTypes = {
  location: PropTypes.object.isRequired, // eslint-disable-line
};

export default withRouter(GoogleAnalytics);
